import React from 'react';
import QuizSubjectTopics from '../../topics/QuizSubjectTopics';

function QuizChemistryTopics() {
  return (
   <>  

   <QuizSubjectTopics name="quiz" link="quiz/biology" type="quiz" subject="chemistry" topic="atoz" subjectName="chemistry" />
   
   </>
  );
}

export default QuizChemistryTopics;